import defaultAttributes from '../defaultAttributes';

const CornerUpRight = [
  'svg',
  defaultAttributes,
  [
    ['polyline', { points: '15 14 20 9 15 4' }],
    ['path', { d: 'M4 20v-7a4 4 0 014-4h12' }],
  ],
];

export default CornerUpRight;
